(function() {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('AnalyticsService', [
        '$rootScope',
        '$http',
        '$log',
        '$q',
        'authenticatedUser',
        'EndpointService',
        'AppConstants',
        'SourceConstant',
        AnalyticsService
    ]);

    function AnalyticsService($rootScope, $http, $log, $q, authenticatedUser, EndpointService, AppConstants, SourceConstant) {
        var analyticsService = {},
            httpMethods = AppConstants.HttpMethods;

        function SERVICE_ROOT() {
            return EndpointService.endpoint() + 'UnifiedSearch';
        }

        // analyticsService.ORG_USER_USERNAME = 'Everyone';

        analyticsService.getAnalytics = function(params) {
            var config = {
                url: SERVICE_ROOT(),
                method: httpMethods.GET,
                params: params
            };
            return $http(EndpointService.tokenize(config)); 
        };
        
        return analyticsService;
    }
}());
